// separate config module for easier refactoring,
// ability to add comments,
// and setting of default values

const config = {
  api: {
    url: process.env.REACT_APP_API_URL,
    // url: "http://localhost:3001" //for local testing
    redirect: process.env.REACT_APP_API_REDIRECT,
  },
}

export default config
